import React from "react";
import Badge from "~/admin/components/Badge";
import CategoryBadge from "~/admin/components/CategoryBadge";
import SocialNetworkAccountCard from "./components/SocialNetworkAccountCard";
import ReactPlayer from "react-player";

export default function InformationsTab({ influencer }) {
  return (
    <>
      <div className="flex space-x-4 mb-2">
        <div className="text-xl">
          {influencer.lastName} {influencer.firstName}
          {" - "}
          <span className="text-lg italic">
            {influencer.gender === "female" ? "Influenceuse" : "Influenceur"}
          </span>
        </div>
        {influencer.user.checkStatus !== "valid" && (
          <Badge color="warning">{influencer.user.checkStatus}</Badge>
        )}
        {influencer.user.checkStatus === "valid" && (
          <>
            {influencer.user.visible ? (
              <Badge color="success">Visible</Badge>
            ) : (
              <Badge color="danger">Invisible</Badge>
            )}
          </>
        )}
      </div>
      <div className="flex flex-row space-x-1">
        {influencer.categories.map((category) => {
          return (
            <CategoryBadge key={category.id}>{category.name}</CategoryBadge>
          );
        })}
      </div>
      <div className="italic">{influencer.bio}</div>
      <div className="flex space-x-4 py-5">
        {influencer.socialNetworkAccounts.map((socialNetworkAccount) => {
          return (
            <SocialNetworkAccountCard
              key={socialNetworkAccount.id}
              socialNetworkAccount={socialNetworkAccount}
            />
          );
        })}
      </div>
      <div className="flex space-x-10">
        <div className="flex flex-col items-center">
          <div>Photo de profil</div>
          <img
            className="max-w-[200px] max-h-[270px]"
            src={influencer.profilePicture}
            alt="Profil"
          />
        </div>
        <div className="flex flex-col">
          <div>Photos</div>
          <div className="flex flex-row space-x-1">
            {influencer.swipePictures.map((image, key) => {
              return (
                <img
                  key={key}
                  className="max-w-[200px] max-h-[270px]"
                  src={image}
                  alt={`swipe ${key}`}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="max-w-[200px] relative my-6">
        <ReactPlayer
          url={influencer.video}
          width="100%"
          height="100%"
          controls
        />
      </div>
    </>
  );
}
